import { TableEmptyState } from '@practium/ui';
import { LogStatus } from '../../../types/log.types';
import type { LogView } from '../../../types/log.types';
import styles from './LogsTable.module.css';

interface LogsTableProps {
	logs: LogView[];
	isFetching?: boolean;
	onRowClick?: (log: LogView) => void;
}

const STATUS_CLASSES: Record<LogStatus, string> = {
	[LogStatus.Info]: styles.badgeInfo,
	[LogStatus.Warn]: styles.badgeWarn,
	[LogStatus.Error]: styles.badgeError,
};

export const LogsTable = ({ logs, isFetching = false, onRowClick }: LogsTableProps) => {
	if (logs.length === 0) {
		return (
			<TableEmptyState
				title="Nenhum log encontrado"
				subtitle="Os logs de atividade do sistema aparecerão aqui"
			/>
		);
	}

	return (
		<div className={styles.tableWrapper}>
			{isFetching && <span className={styles.refetchIndicator}>Atualizando...</span>}
			<table className={styles.table}>
				<thead className={styles.thead}>
					<tr>
						<th>Tipo</th>
						<th>Ação</th>
						<th>Usuário</th>
						<th>Timestamp</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody className={styles.tbody}>
					{logs.map(item => (
						<tr
							key={item.id}
							onClick={() => onRowClick?.(item)}
							className={onRowClick ? styles.clickableRow : undefined}
						>
							<td>
								<span className={styles.cellPrimary}>{item.tipo}</span>
							</td>
							<td>
								<span className={`${styles.cellSecondary} ${styles.actionText}`} title={item.acao}>
									{item.acao}
								</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.usuario}</span>
							</td>
							<td>
								<span className={styles.cellSecondary}>{item.timestamp}</span>
							</td>
							<td>
								<span className={`${styles.badge} ${STATUS_CLASSES[item.status]}`}>
									{item.statusLabel}
								</span>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};
